export const VIEW_AS_CLIENT_KEY = 'VIEW_AS_CLIENT';
export const SELECTED_CLIENT_ID_KEY = 'SELECTED_CLIENT_ID';
export const SELECTED_CLIENT_NAME_KEY = 'SELECTED_CLIENT_NAME';

declare global {
    interface Window {
        applyClientView: () => void;
        applyAdminView: () => void;
    }
}

if (typeof window !== 'undefined') {
    // Import service dynamically to avoid circular dependencies
    window.applyClientView = () => {
        import('@/helpers/clientViewService').then(({ clientViewService }) => {
            clientViewService.setViewAsClient(true);
        });
    };
    window.applyAdminView = () => {
        import('@/helpers/clientViewService').then(({ clientViewService }) => {
            clientViewService.clearClientViewData();
        });
    };
}
